import { useState, useEffect } from "react";
import axios from "axios";
import { toast } from "sonner";
import { pushGtmEvent } from "@/lib/gtm";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;
const EMPTY_LEAD = { name: "", email: "", phone: "", consent: false };

const validateLead = (lead) => {
  if (!lead.consent) return "Você precisa aceitar a Política de Privacidade.";
  if (!lead.name || !lead.email || !lead.phone) return "Preencha todos os campos.";
  return null;
};

// Holds all quiz state and transitions (0=perfil, 1=perguntas, 2=dados, 3=resultado)
export const useQuizFlow = (initialProfile, isValidProfile, totalQuestions) => {
  const startsWithProfile = isValidProfile(initialProfile);
  const [step, setStep] = useState(startsWithProfile ? 1 : 0);
  const [profile, setProfile] = useState(startsWithProfile ? initialProfile : "");
  const [answers, setAnswers] = useState({});
  const [qIndex, setQIndex] = useState(0);
  const [lead, setLead] = useState(EMPTY_LEAD);
  const [loading, setLoading] = useState(false);
  const [result, setResult] = useState(null);

  useEffect(() => {
    if (isValidProfile(initialProfile)) {
      setProfile(initialProfile);
      setStep(1);
    }
  }, [initialProfile, isValidProfile]);

  const selectProfile = (slug) => {
    setProfile(slug);
    setStep(1);
  };

  const answer = (qid, value) => {
    setAnswers((prev) => ({ ...prev, [qid]: value }));
    if (qIndex < totalQuestions - 1) {
      setQIndex(qIndex + 1);
    } else {
      setStep(2);
    }
  };

  const prevQuestion = () => setQIndex(qIndex - 1);

  const submit = async (e) => {
    e.preventDefault();
    const error = validateLead(lead);
    if (error) {
      toast.error(error);
      return;
    }
    setLoading(true);
    try {
      const res = await axios.post(`${API}/quiz/submit`, { profile, answers, ...lead });
      setResult(res.data);
      setStep(3);
      pushGtmEvent("quiz_completed", { profile });
    } catch (err) {
      toast.error("Não conseguimos gerar sua análise agora. Tente novamente em instantes.");
    } finally {
      setLoading(false);
    }
  };

  const restart = () => {
    setStep(0);
    setProfile("");
    setAnswers({});
    setQIndex(0);
    setLead(EMPTY_LEAD);
    setResult(null);
  };

  return { step, qIndex, lead, setLead, loading, result, selectProfile, answer, prevQuestion, submit, restart };
};
